export default defineNuxtRouteMiddleware(async (nuxt) => {
  const isValidBaseUrl =
    nuxt.params.type === localStorage.getItem("courseType");
    const isMaintenanceMode = usePublicInfoStore().toggleList.find(
    (feature) => feature.name === "SWAJAR",
  );
  if (isMaintenanceMode?.name === "SWAJAR") {
    usePublicInfoStore().$patch((state) => {
      state.toggleFeature = {
        message: isMaintenanceMode?.message || "",
        name: isMaintenanceMode?.name || "",
        status: isMaintenanceMode?.status || false,
        startTime: isMaintenanceMode?.startTime || null,
        endTime: isMaintenanceMode?.endTime || null,
      };
    });
    if (usePublicInfoStore().isMaintenanceMode)
      return navigateTo({ path: "/maintenance", query: { page: "SWAJAR" } });
  }
  if (!isValidBaseUrl) {
    useBelajarWajibStore().clearTokens();
    return navigateTo({ path: "/revamp/login" });
  }
  if (localStorage.getItem("dataPegawai")) {
    useBelajarWajibStore().$patch((state) => {
      state.dataPegawai = JSON.parse(localStorage.getItem("dataPegawai")) || {};
    });
  }
  if (localStorage.getItem("profile")) {
    useBelajarWajibStore().$patch((state) => {
      state.profile = JSON.parse(localStorage.getItem("profile")) || {};
    });
  }
  if (localStorage.getItem("courseList")) {
    useBelajarWajibReaderStore().$patch((state) => {
      state.courseList = JSON.parse(localStorage.getItem("courseList")) || [];
    });
  }
});
